
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import PromiseSection from '../../components/feature/PromiseSection';
import AccommodationSection from '../../components/feature/AccommodationSection';
import GallerySection from '../../components/feature/GallerySection';
import LocationSection from '../../components/feature/LocationSection';
import BeachesSection from '../../components/feature/BeachesSection';
import ParkInfoSection from '../../components/feature/ParkInfoSection';
import ReservationForm from '../../components/feature/ReservationForm';
import Footer from '../../components/feature/Footer';
import { updateSEO, addStructuredData } from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    // Update SEO
    updateSEO({
      title: 'Castilletes Parque Tayrona - Tu Oasis Frente a Playa Castilletes',
      description: 'Vive la magia del Tayrona con comodidad en Castilletes. Habitaciones, carpas y hamacas frente a la playa. Piscina, desayuno incluido y acceso directo a las mejores playas del Caribe colombiano.',
      keywords: 'Castilletes, Parque Tayrona, alojamiento, playa, Colombia, Caribe, piscina, naturaleza, ecoturismo',
      canonical: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
    });

    // Add structured data
    addStructuredData({
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      "name": "Castilletes Parque Tayrona",
      "description": "Alojamiento ecológico en el Parque Nacional Tayrona con habitaciones, carpas y hamacas frente a la playa",
      "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
      "telephone": "+57-300-000-0000",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Parque Nacional Natural Tayrona",
        "addressLocality": "Santa Marta",
        "addressRegion": "Magdalena",
        "addressCountry": "CO"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "11.3167",
        "longitude": "-74.0833"
      },
      "amenityFeature": [
        {
          "@type": "LocationFeatureSpecification",
          "name": "Piscina",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "WiFi gratuito",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Desayuno incluido",
          "value": true
        },
        {
          "@type": "LocationFeatureSpecification",
          "name": "Acceso directo a la playa",
          "value": true
        }
      ],
      "checkinTime": "14:00",
      "checkoutTime": "11:00",
      "petsAllowed": false,
      "smokingAllowed": false
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <PromiseSection />
      <AccommodationSection />
      <GallerySection />
      <LocationSection />
      <BeachesSection />
      <ParkInfoSection />
      
      {/* Formulario de Reserva */}
      <section id="contact" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <ReservationForm />
        </div>
      </section>
      
      <Footer />
    </div>
  );
}
